<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 0C4.9 0 0 4.79 0 10.753C0 16.716 4.9 21.507 11 21.507C17.1 21.507 22 16.717 22 10.753C22 4.79 17.1 0 11 0ZM11 19.551C6 19.551 2 15.641 2 10.753C2 5.865 6 1.955 11 1.955C16 1.955 20 5.865 20 10.753C20 15.641 16 19.551 11 19.551Z" fill="currentColor"/>
</svg>
